<template>

    <stat-box-numerical
            :value="responseRate"
            postfix="%"
            hint="Response rate"
            :hint-at-top="true"
            :color="calculateResponseRateColor(responseRate)"
            :height="height"
            mouse-over-hint="Start rate"
            :mouse-over-value="startRate"
            mouse-over-postfix="%"
            :mouse-over-color="calculateStartRateColor(startRate)"
    ></stat-box-numerical>

</template>

<script>

    import StatBoxNumerical from '../../../components/UI/StatBoxNumerical';
    import {rateColorMixin} from "../../../components/mixins/rateColorMixin";
    import {numberDisplay} from '../../../components/mixins/numberDisplayMixin';

    export default {

        mixins: [rateColorMixin, numberDisplay],

        components: {
            StatBoxNumerical
        },

        props: {
            project: {
                type: Object,
                required: true
            },
            height: {
                type: Number,
                required: false,
                default: 100,
            }
        },

        computed: {

            responseRate() {

                let responseRate = 0;

                if (this.project.completed_count - this.project.routed_in_completes > 0 && this.project.invited_count > 0) {
                    responseRate = (this.project.completed_count - this.project.routed_in_completes) / this.project.invited_count * 100;
                }

                if (responseRate < 3) {
                    return this.roundValue(responseRate,1);
                }

                return Math.round(responseRate);
            },

            startRate() {
                if (this.project.started_count - this.project.routed_in_count > 0 && this.project.invited_count > 0) {
                    return Math.round((this.project.started_count - this.project.routed_in_count) / this.project.invited_count * 100);
                } else {
                    return 0;
                }
            },
        },
    }
</script>
